import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getDeliveryType} from '../../v2/selectors/selectors';
import getIsCollectionEnabled from '../../v2/selectors/getIsCollectionEnabled';

import GenericSection from '../GenericSection/GenericSection';
import DeliveryOptionSection from './DeliveryOptionSection';

export function DeliveryOptionSectionWrapper(props) {
  const checkClickAndCollection = () => {
    if (props.isCollectionEnabled) {
      return props.isDeliveryTypePudo ? 'checkout.select.collect.title' : 'checkout.select.delivery.title';
    }
    return 'checkout.select.delivery.legend.text';
  };
  
  return (
    <div data-test="DeliveryOptionSection">
      <GenericSection
        {...props}
        id="delivery-options-section-heading"
        headerKey={checkClickAndCollection()}
      >
        <DeliveryOptionSection isStepCollapsed={props.isStepCollapsed} />
      </GenericSection>
    </div>
  );
}

DeliveryOptionSectionWrapper.propTypes = ({
  step: PropTypes.number.isRequired,
  isStepActive: PropTypes.bool.isRequired,
  isStepPending: PropTypes.bool.isRequired,
  isStepCollapsed: PropTypes.bool.isRequired,
  isDeliveryTypePudo: PropTypes.bool.isRequired,
  isCollectionEnabled: PropTypes.bool.isRequired,
});

const mapStateToProps = state => ({
  isDeliveryTypePudo: getDeliveryType(state) === 'pudo',
  isCollectionEnabled: getIsCollectionEnabled(state),
});

export default connect(mapStateToProps)(DeliveryOptionSectionWrapper);
